module.exports = "/_next/static/images/log-ddf5c6f0d6424e905173ff91b81ab150.svg";